export default __webpack_public_path__ + "static/media/share-dark.01a62f12.svg";